"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_calendar_1 = __importDefault(require("react-calendar"));
var DEFAULT_START_TIME = 10;
var DEFAULT_END_TIME = 20;
var buildTimeSelectOptions = function (start, end) { return (__spreadArray([
    { value: undefined, label: '時間を選択' }
], __spreadArray([], Array((end - start) * 2 + 1), true).map(function (_, idx) { return ({
    value: idx + 1, label: "".concat(start + Math.floor(idx / 2), ":").concat(idx % 2 === 0 ? '00' : '30')
}); }), true)); };
var formattedDate = function (date) { return (0, moment_1.default)(date).format('YYYY/MM/DD'); };
var SelectDateForm = function (_a) {
    var priority = _a.priority, onClickConfirm = _a.onClickConfirm, selectedDate = _a.selectedDate, selectedReservedDates = _a.selectedReservedDates;
    var timeOptions = buildTimeSelectOptions(DEFAULT_START_TIME, DEFAULT_END_TIME);
    var _b = react_1.default.useState(selectedDate ? new Date(selectedDate.date) : new Date()), date = _b[0], setDate = _b[1];
    var _c = react_1.default.useState(), selectedStartTimeIdx = _c[0], setSelectedStartTimeIdx = _c[1];
    var _d = react_1.default.useState(), selectedEndTimeIdx = _d[0], setSelectedEndTimeIdx = _d[1];
    var _e = react_1.default.useState(false), disableConfirm = _e[0], setDisableConfirm = _e[1];
    react_1.default.useEffect(function () {
        var reservationDate = {
            date: formattedDate(date),
            startAt: selectedStartTimeIdx && timeOptions[selectedStartTimeIdx],
            endAt: selectedEndTimeIdx && timeOptions[selectedEndTimeIdx]
        };
        var selectedSameDate = selectedReservedDates.some(function (rDate) { return (0, isEqual_1.default)(reservationDate, rDate); });
        setDisableConfirm(!selectedStartTimeIdx || !selectedEndTimeIdx || selectedSameDate || selectedStartTimeIdx >= selectedEndTimeIdx);
    }, [date, selectedStartTimeIdx, selectedEndTimeIdx]);
    var handleChangeCalendar = function (value) {
        setDate(Array.isArray(value) ? value[0] : value);
    };
    var handleClickConfirm = function () {
        if (!selectedStartTimeIdx || !selectedEndTimeIdx) {
            return;
        }
        onClickConfirm({
            date: formattedDate(date),
            startAt: timeOptions[selectedStartTimeIdx].label,
            endAt: timeOptions[selectedEndTimeIdx].label
        });
        setSelectedStartTimeIdx(undefined);
        setSelectedEndTimeIdx(undefined);
        setDate(new Date());
    };
    return (react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-ReservationDateModal_SelectDateFormBox" },
        react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-ReservationDateModal_SelectDateFormTitle" },
            "\u7B2C",
            priority,
            "\u5E0C\u671B\u65E5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
        react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-ReservationDateModal_CalendarWrapper" },
            react_1.default.createElement(react_calendar_1.default, { value: date, minDate: new Date(), maxDate: (0, moment_1.default)().add(2, 'weeks').toDate(), onChange: handleChangeCalendar })),
        react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-ReservationDateModal_SelectTimeWrapper" },
            react_1.default.createElement("select", { onChange: function (e) { return e.target.value && setSelectedStartTimeIdx(Number(e.target.value)); }, className: "usersEstimatesRequestsMessages-ReservationDateModal_Select" }, timeOptions.map(function (_a) {
                var label = _a.label, value = _a.value;
                return (react_1.default.createElement("option", { key: value, value: value }, label));
            })),
            react_1.default.createElement("span", { className: "usersEstimatesRequestsMessages-ReservationDateModal_Tilde" }, "\u301C"),
            react_1.default.createElement("select", { onChange: function (e) { return e.target.value && setSelectedEndTimeIdx(Number(e.target.value)); }, className: "usersEstimatesRequestsMessages-ReservationDateModal_Select" }, timeOptions.map(function (_a) {
                var label = _a.label, value = _a.value;
                return (react_1.default.createElement("option", { key: value, value: value }, label));
            }))),
        react_1.default.createElement("button", { onClick: handleClickConfirm, disabled: disableConfirm, className: "sw-Button sw-Button-controlSub usersEstimatesRequestsMessages-ReservationDateModal_FormConfirmButton" }, "\u78BA\u5B9A")));
};
exports.default = SelectDateForm;
